import { Box, Typography } from '@mui/material';
import parse from 'html-react-parser';

import AttachmentsAccordion from '../../common/AttachmentsAccordion';

import { Comment } from 'services/help-center/queries/useTicketComments/useTicketComments.interface';
import sanitizeHtml from 'modules/common/utils/sanitizeHtml';

interface InitialMessageProps {
    initialMessage: Comment;
}

export default function InitialMessage({ initialMessage }: InitialMessageProps) {
    if (!initialMessage?.html_body) {
        return null;
    }

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: 0.75,
                paddingX: 2,
                paddingY: 1.5,
                backgroundColor: 'purple.50',
                borderRadius: 2,
                marginBottom: 2,
            }}>
            <Typography variant="h6" component="p">
                Your description:
            </Typography>
            <Typography variant="body2" component="span">
                {parse(sanitizeHtml(initialMessage.html_body))}
            </Typography>

            {initialMessage.attachments?.length > 0 && (
                <AttachmentsAccordion attachments={initialMessage.attachments} />
            )}
        </Box>
    );
}
